(function () {
  /* ======================== CONFIG / UTILS ======================== */
  const DEBUG_NO_NAV = false; // <-- set to false when you're done debugging

  const isDesktop = () => window.matchMedia('(min-width: 1200px)').matches;
  const isMobile  = () => window.matchMedia('(max-width: 1199px)').matches;
  const once = (el, key) => { if (el.hasAttribute(key)) return false; el.setAttribute(key, ''); return true; };
  const deB  = (el, win = 120) => { const now = Date.now(), last = +el.dataset.lastFireTs || 0; if (now - last < win) return false; el.dataset.lastFireTs = now; return true; };
  const stopNav = (e, anchor) => {
    if (!DEBUG_NO_NAV) return;
    if (e && e.preventDefault) e.preventDefault();
    if (anchor) anchor.setAttribute('data-debug-blocked', '1');
    try { console.info('[debug] nav blocked:', anchor?.href || '(no href)'); } catch(_) {}
  };

  /* ======================== POSITION MAPPING (sequential) ======================== */
  (function(){
    const KEY='data-lp-pos-init';
    if (document.documentElement.hasAttribute(KEY)) return;
    document.documentElement.setAttribute(KEY,'');

    const tabs = Array.from(document.querySelectorAll('.global-menu-design a[data-topnav="true"]'));
    tabs.forEach((a,i)=>{ 
      a.dataset.lpPos = String(2 + i);      // 1 = Logo, then 2..N for tabs
      a.dataset.topIndex = a.dataset.lpPos;
    });

    const search  = document.querySelector('.predictive-search__input');
    if (search)  search.dataset.lpPos = '6';

    const cart    = document.querySelector('.header__icon--cart a, #cart-icon-bubble a, a[href="/cart"]');
    if (cart)    cart.dataset.lpPos = '7';

    const profile = document.querySelector('.sign-in');
    if (profile) profile.dataset.lpPos = '8';
  })();

  /* ======================== DESKTOP: TOP NAV TABS (INTERNALLINK) ======================== */
  if (once(document.documentElement, 'data-lptrk-topnav')) {
    document.addEventListener('click', (e) => {
      if (!isDesktop()) return;
      const a = e.target.closest('.global-menu-design a[data-topnav="true"]');
      if (!a || !deB(a, 120)) return;
      stopNav(e, a);
      tagular("ElementClicked", {
        actionOutcome: "INTERNALLINK",
        outboundUrl: a.href || null,
        webElement: {
          elementType: "Tab",
          htmlId: a.id || null,
          location: "Global Nav",
          name: a.dataset.menuTitle || a.textContent.trim(),
          position: (a.dataset.lpPos || a.dataset.topIndex || "").toString(),
          text: a.textContent.trim(),
          variant: null
        }
      });
    });
  }

  /* ======================== DESKTOP: SUBNAV LEFT TABS (OPEN) ======================== */
  document.documentElement.removeAttribute('data-lptrk-megatabs');
  if (!document.documentElement.hasAttribute('data-lptrk-megatabs')) {
    document.documentElement.setAttribute('data-lptrk-megatabs', '');
    document.addEventListener('click', (e) => {
      if (!isDesktop()) return;
      const btn = e.target.closest('.mega-tab-btn');
      if (!btn || !deB(btn,100)) return;

      const mm = btn.closest('.mega-menu'); if (!mm || !mm.id) return;
      const trigger  = document.querySelector('[aria-controls="' + mm.id + '"]');
      const topTitle = (trigger && (trigger.dataset.menuTitle || trigger.textContent.trim())) || 'Unknown';

      const all = btn.parentElement ? Array.from(btn.parentElement.querySelectorAll('.mega-tab-btn')) : [];
      const pos = (all.indexOf(btn) + 1) || '';

      tagular("ElementClicked", {
        actionOutcome: "OPEN",
        outboundUrl: null,
        webElement: {
          elementType: "Tab",
          htmlId: btn.id || null,
          location: `Sub Nav - ${topTitle}`,
          name: (btn.textContent || '').trim(),
          position: pos.toString(),
          text: (btn.textContent || '').trim(),
          variant: null
        }
      });
    });
  }

  /* ======================== DESKTOP: SUBNAV PANEL LINKS (GENERIC LINKS, exclude CTA aside) ======================== */
  document.documentElement.removeAttribute('data-lptrk-megalinks');
  if (!document.documentElement.hasAttribute('data-lptrk-megalinks')) {
    document.documentElement.setAttribute('data-lptrk-megalinks', '');
    document.addEventListener('click', (e) => {
      if (!isDesktop()) return;
      const a = e.target.closest('.mega-menu .tab-panel a[href]');
      if (!a || a.closest('.mm-links-cta__aside')) return;  // exclude CTA aside (handled below)
      if (!deB(a,100)) return;

      const mm = a.closest('.mega-menu'); if (!mm) return;
      const panel   = a.closest('.tab-panel') || mm;
      const trigger = document.querySelector(`[aria-controls="${mm.id}"]`);
      const topTitle = (trigger && (trigger.dataset.menuTitle || trigger.textContent.trim())) || 'Unknown';

      const activeBtn = mm.querySelector('.mega-tab-btn.is-active, .mega-tab-btn[aria-selected="true"]');
      const tabName   = activeBtn ? (activeBtn.textContent || '').trim() : '';
      const locationDefault = tabName ? `Sub Nav - ${topTitle} - ${tabName}` : `Sub Nav - ${topTitle}`;

      const links = Array.from(panel.querySelectorAll('a[href]'));
      const pos   = String((links.indexOf(a) + 1) || 1);
      const href  = a.getAttribute('href') || null;

      let nameEl   = a.querySelector('[data-menu-title],[data-title],[class*="title"],h1,h2,h3,h4,h5,h6,strong,b') || a.querySelector(':scope > span');
      let baseName = (nameEl ? nameEl.textContent : a.getAttribute('title') || '').trim();
      if (!baseName) {
        const directText = Array.from(a.childNodes).filter(n => n.nodeType === 3).map(n => n.textContent).join(' ').replace(/\s+/g,' ').trim();
        baseName = directText || (a.textContent || '').trim();
      }

      stopNav(e, a);
      tagular("ElementClicked", {
        actionOutcome: "INTERNALLINK",
        outboundUrl: href,
        webElement: {
          elementType: "Link",
          htmlId: a.id || null,
          location: locationDefault,
          name: baseName,
          position: pos,
          text: baseName,
          variant: null
        }
      });
    });
  }

  /* ======================== DESKTOP: VIEW ALL LINKS (ElementClicked) ======================== */
  if (once(document.documentElement,'data-lptrk-viewall-links')) {
    document.addEventListener('click', (e) => {
      if (!isDesktop()) return;

      const a = e.target.closest('.mega-menu .mm-viewall[href]');
      if (!a || !deB(a,120)) return;

      const mm = a.closest('.mega-menu'); if (!mm) return;
      const trigger  = document.querySelector(`[aria-controls="${mm.id}"]`);
      const topTitle = (trigger && (trigger.dataset.menuTitle || trigger.textContent.trim())) || (mm.dataset.menuTitle || '').trim();

      const labelUpper = `VIEW ALL ${topTitle}`.toUpperCase();

      stopNav(e, a);

      tagular("ElementClicked", {
        actionOutcome: "INTERNALLINK",
        outboundUrl: a.href || null,
        webElement: {
          elementType: "Link",
          location: `Sub Nav - ${topTitle}`,
          name: labelUpper,
          text: labelUpper
        }
      });
    });
  }

  /* ======================== DESKTOP: FEATURE PLACEMENTS (CTA ASIDE) VIEW + CLICK ======================== */
  (() => {
    // Fire ProductViewed when the mega-menu panel becomes visible (Books/Trips only)
    const triggers = Array.from(document.querySelectorAll('.global-menu-design > li > a[data-topnav="true"]'));
    triggers.forEach(trigger => {
      const top = (trigger.dataset.menuTitle || trigger.textContent || '').trim();
      if (top !== 'Books' && top !== 'Trips' && top !== 'Destinations') return;

      const mmId = trigger.getAttribute('aria-controls');
      const mm = mmId ? document.getElementById(mmId) : null;
      if (!mm) return;

      const fireView = (ctaLink) => {
        const btnText = (ctaLink.textContent || '').trim();
        if (!btnText) return;
        if (top === 'Books' || top === 'Trips') {
          tagular('ProductViewed', {
            product: {
              brand: top === 'Books' ? 'SHOP' : 'Elsewhere',
              category: top === 'Books' ? 'Book' : 'Trip',
              formatSubtype: null,
              formatType: null,
              location: `Sub Nav - ${top}`,
              name: btnText,
              pageId: null,
              position: null,
              price: null,
              productId: null,
              quantity: null,
              sku: null,
              subscription: { frequency: null },
              text: btnText,
              upc: null,
              variant: null,
              positionEngine: null
            }
          });
        }
      };

      const observer = new MutationObserver(() => {
        if (!isDesktop()) return;
        const nowVisible = !mm.hasAttribute('hidden');
        if (!nowVisible) return;
        const cta = mm.querySelector('.mm-links-cta__aside a[href]');
        if (!cta) return;
        fireView(cta); // re-fires every time the panel becomes visible
      });

      observer.observe(mm, { attributes: true, attributeFilter: ['hidden'] });
    });

    // ProductClicked / ElementClicked on CTA aside (click)
    document.addEventListener('click', (e) => {
      if (!isDesktop()) return;
      const link = e.target.closest('.mm-links-cta__aside a[href]');
      if (!link || !deB(link,120)) return;

      const mm = link.closest('.mega-menu'); if (!mm) return;
      const trigger = document.querySelector(`[aria-controls="${mm.id}"]`);
      const top = (trigger && (trigger.dataset.menuTitle || trigger.textContent.trim())) || '';

      stopNav(e, link); // usa tu flag DEBUG_NO_NAV para bloquear navegación en debug

      if (top === 'Destinations') {
        const label = (link.textContent || 'Start Discovering').trim();
        tagular('ElementClicked', {
          actionOutcome: 'INTERNALLINK',
          outboundUrl: link.href || null,
          webElement: {
            elementType: 'Link',
            location: `Sub Nav - ${top}`,
            name: label.toUpperCase(),
            text: label.toUpperCase()
          }
        });
      } else if (top === 'Books' || top === 'Trips') {
        const btnText = (link.textContent || '').trim();
        tagular('ProductClicked', {
          actionOutcome: 'INTERNALLINK',
          outboundUrl: link.href || null,
          product: {
            brand: top === 'Books' ? 'SHOP' : 'Elsewhere',
            category: top === 'Books' ? 'Book' : 'Trip',
            formatSubtype: null,
            formatType: null,
            location: `Sub Nav - ${top}`,
            name: btnText,
            pageId: null,
            position: null,
            price: null,
            productId: null,
            quantity: null,
            sku: null,
            subscription: { frequency: null },
            text: btnText,
            upc: null,
            variant: null,
            positionEngine: null
          }
        });
      }
    });
  })();


  /* ======================== SEARCH: FOCUS (ElementClicked SEARCH) ======================== */
  (function () {
    const input = document.querySelector('.predictive-search__input');
    if (!input || !once(input, 'data-lptrk-search')) return;
    let armed = true;
    const fire = () => {
      if (!armed) return;
      armed = false;
      tagular("ElementClicked", {
        actionOutcome: "SEARCH",
        outboundUrl: null,
        webElement: {
          elementType: "Text Field",
          htmlId: input.id || null,
          location: "Global Nav",
          name: "Search Bar",
          position: "6",
          text: input.value || null,
          variant: null
        }
      });
    };
    input.addEventListener('focus', fire);
    input.addEventListener('blur', () => { armed = true; });
  })();

  /* ======================== SEARCH: SUBMIT (SearchQuerySubmitted) ======================== */
  (function () {
    const form = document.querySelector('.predictive-search__form');
    const input = document.querySelector('.predictive-search__input');
    if (!form || !input || !once(form, 'data-lptrk-searchsubmit')) return;
    form.addEventListener('submit', () => {
      const suggested = !!document.querySelector('predictive-search-drawer .resource-wrapper.queries')
        || !!document.querySelector('.predictive-search__results .queries');
      tagular("SearchQuerySubmitted", {
        rawSearchQuery: input.value || "",
        searchAutoSuggested: suggested ? "true" : "null"
      });
    });
  })();

  /* ======================== LOGO (INTERNALLINK) ======================== */
  (function () {
    const lpLogo = document.querySelector('.header__logo-image.header__logo-image--transparent') || document.querySelector('.header__logo-link .header__logo-image');
    if (!lpLogo || !once(lpLogo, 'data-lptrk-logo')) return;
    lpLogo.addEventListener('click', (e) => {
      const link = lpLogo.closest('a');
      stopNav(e, link);
      tagular("ElementClicked", {
        actionOutcome: "INTERNALLINK",
        outboundUrl: (link && link.href) || window.location.href,
        webElement: {
          elementType: "Button",
          htmlId: lpLogo.id || null,
          location: "Global Nav",
          name: "LP Logo",
          position: "1",
          text: null,
          variant: null
        }
      });
    });
  })();

  /* ======================== PROFILE (INTERNALLINK) ======================== */
  (function () {
    const profile = document.querySelector('.sign-in');
    if (!profile || !once(profile, 'data-lptrk-profile')) return;
    profile.addEventListener('click', (e) => {
      stopNav(e, profile);
      tagular("ElementClicked", {
        actionOutcome: "INTERNALLINK",
        outboundUrl: (e.currentTarget && e.currentTarget.href) || null,
        webElement: {
          elementType: "Button",
          htmlId: profile.id || null,
          location: "Global Nav",
          name: "Profile",
          position: "8",
          text: null,
          variant: null
        }
      });
    });
  })();

  /* ======================== MOBILE: HAMBURGER (OPEN/CLOSE) ======================== */
  (function () {
    const btn = document.getElementById('mobile-menu-button')
      || document.querySelector('.header__icon-wrapper[aria-controls="mobile-menu-drawer"]')
      || document.querySelector('button#mobile-menu-drawer-toggle');

    if (!btn || !once(btn, 'data-lptrk-hamburger')) return;

    btn.addEventListener('click', () => {
      if (!isMobile() || !deB(btn, 150)) return;
      setTimeout(() => {
        const drawer = document.getElementById('lp-mobile');
        const nowOpen = !!(drawer && !drawer.hidden && drawer.classList.contains('lpmm--open'));
        tagular("ElementClicked", {
          actionOutcome: nowOpen ? "OPEN" : "CLOSE",
          outboundUrl: null,
          webElement: {
            elementType: "Button",
            htmlId: btn.id || null,
            location: "Global Nav",
            name: "Global Nav Hamburger",
            position: null,
            text: null,
            variant: null
          }
        });
      }, 0);
    });
  })();

  /* ======================== MOBILE: TOP-LEVEL CATEGORY TABS ======================== */
  (function () {
    const root = document.getElementById('lp-mobile');
    if (!root || !once(root, 'data-lptrk-mobile-toplevel')) return;

    const bind = () => {
      const items = Array.from(root.querySelectorAll('.lpmm__list > .lpmm__item .lpmm__trigger'));
      items.forEach((btn, idx) => {
        if (btn.__lpHandler) btn.removeEventListener('click', btn.__lpHandler);
        const handler = () => {
          if (!isMobile() || !deB(btn, 120)) return;
          tagular("ElementClicked", {
            actionOutcome: "OPEN",
            outboundUrl: null,
            webElement: {
              elementType: "Tab",
              htmlId: btn.id || null,
              location: "Global Nav",
              name: btn.dataset.menuTitle || (btn.textContent || '').trim(),
              position: String(idx + 1),
              text: "",
              variant: null
            }
          });
        };
        btn.__lpHandler = handler;
        btn.addEventListener('click', handler);
      });
    };

    bind();
    const mq = window.matchMedia('(max-width: 1199px)');
    mq.addEventListener ? mq.addEventListener('change', bind) : mq.addListener(bind);
  })();

  /* ======================== MOBILE: ACCORDION EXPAND ======================== */
  (function () {
    const root = document.getElementById('lp-mobile');
    if (!root || !once(root, 'data-lptrk-mobile-accordion')) return;

    root.addEventListener('click', (e) => {
      if (!isMobile()) return;
      const trig = e.target.closest('.lpmm-sec__trigger');
      if (!trig || !root.contains(trig) || !deB(trig, 120)) return;

      const panel = trig.closest('.lpmm__panel');
      const mainTab = (panel && panel.querySelector('.lpmm__subtitle') && panel.querySelector('.lpmm__subtitle').textContent.trim()) || 'Mobile';

      tagular("ElementClicked", {
        actionOutcome: "EXPAND",
        outboundUrl: null,
        webElement: {
          elementType: "Tab",
          htmlId: trig.id || null,
          location: `Sub Nav - ${mainTab}`,
          name: (trig.textContent || '').trim(),
          position: null,
          text: '',
          variant: null
        }
      });
    });
  })();

})();
